import ClinicalAssessment from 'dashboard/templates/views/Encounter/ClinicalAssessment';

export default {
  path: 'clinical-assessment',
  name: 'PatientEncounterClinicalAssessment',
  component: ClinicalAssessment,
  props: true,
  meta: {
    // title: 'Encounter - Clinical Assessment',
    title: t => t('encounter.clinicalAssessment'),
    loggedInOnly: true,
  }
};
